<template>
  <span v-show="false" />
</template>

<script>
import asyncPlugins from '@/plugins/asyncPlugins';
import '@/event.init';
import { InitSentry } from 'utils/sentry';
export default {
  name: 'async-render',
  created() {
    // api式插件
    this.constructor.use(asyncPlugins);
    // sentry
    InitSentry();
  },
};
</script>
